<template>
  <div class="brief">
    <div class="row">
      <!-- 右边 -->
      <div class="fr w750">
        <div class="pageBox2">
          <div class="about">
            <ul>
              <li v-for="item in dataDynamic" :key="item.id" @click="onClickDataNotice(item.id)">
                <a href="#">{{item.title}}</a>
                <span>{{item.createTime}}</span>
              </li>
            </ul>
          </div>
          <div class="pages">
              <el-pagination :page-size="15" @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                layout="prev, pager, next" :total="total">
              </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dataDynamic: [],
        total: 0,
        isActive: 1,
        queryParams: {
          pageNum: 1,
          pageSize: 15,
          title: this.$route.query.title
        }
      }
    },
    mounted() {
      this.getlist();
    },
    methods: {
      // 获取协会公告的列表数据
      getlist() {
        this.$axios.get('/websiteData/title/allList', {
          params: this.queryParams
        }).then(res => {
          this.dataDynamic = res.data.rows;
          this.total = res.data.total;
        })
      },
      handleSizeChange(row) {
        this.queryParams.pageSize = row;
        this.getlist();
      },
      handleCurrentChange(row) {
        this.queryParams.pageNum = row;
        this.getlist();
      },
      onClickDataNotice(id) {
        this.$router.push({
          path: '/searchs',
          query: {
            id: id,
            isActive: this.isActive,
          }
        })
      },
    },
    watch: {
      $route(api) {
        this.queryParams.title = api.query.title;
        this.getlist();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .brief {
    margin: 20px 0;
    overflow: hidden;

    .row {
      width: 1000px;
      background-color: #FFF;
      margin: 0 auto;

      .w750 {
        width: 100%;
        position: relative;
        right: -7px;

        .pageBox2 {
          min-height: 830px;
          border: 1px #DDDDDD solid;
          border-radius: 5px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
            0 0 6px 0 rgba(0, 0, 0, 0.04);

          .about {
            padding: 45px 35px;
            font-size: 14px;
            line-height: 20px;
            text-align: justify;

            ul {
              li {
                height: 41px;
                line-height: 40px;
                overflow: hidden;
                position: relative;
                background: url('../../assets/image/line.gif') bottom repeat-x;

                a {
                  background: url('../../assets/image/icons.gif') left center no-repeat;
                  font-size: 14px;
                  padding-left: 12px;
                }

                span {
                  color: #999;
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  white-space: nowrap;
                }
              }
            }
          }

          .pages {
              padding: 20px 0;
              display: flex;
              justify-content: center;
            }
        }
      }
    }
  }
</style>
